@if (dokulinkVerfuegbar | async; as verfuegbar) {
  <span style="margin: 0 3px">
    @if (verfuegbar === "DOKULINK_VORHANDEN") {
      @let tooltipText = ("DokumenteZu" + this.dokulinkItem.type | translate : {param: dokulinkItem.tooltipParam});
      <button
        (click)="openDokuLink()"
        [disableTooltip]="false"
        [ngbTooltip]="tooltipText"
        [placement]="'top'"
        class="ms-0 p-0"
        container="body">
        <span aria-hidden="true" class="far fa-file-pdf fa-lg align-middle" style="text-decoration: none; font-size: 0.9em"></span>
        @if (_showTitle) {
          <span style="margin-left: 3px">
            {{ ("DokumenteZu" + this.dokulinkItem.type) | translate }}
          </span>
        }
      </button>
    }
  </span>
}
